import * as React from "react";
import { SVGProps } from "../types";

const AmericanExpressIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path fill="#1271CD" d="M2 2h28v28H2z"></path>
    <path
      fill="#fff"
      d="m8.523 16.56 4.479-10.01h4.267l1.516 3.395V6.55h5.325l.882 2.625.917-2.625h4.09v1.19h-3.244l-1.728 4.76-1.798-4.76h-3.315v7.665L16.529 7.74h-2.786l-3.421 7.665h2.363l.6-1.505h3.596l.635 1.505h4.514v-5.32l1.975 5.32h1.904l2.045-5.32v5.32H30v1.155h-2.751l-2.292 2.45-2.257-2.45h-9.38v7.7h9.38l2.257-2.45 2.292 2.45h2.75v1.155h-3.314l-1.693-1.89-1.799 1.89H12.086V16.56z"
    ></path>
    <path
      fill="#fff"
      d="M30 24.26v-1.577l-2.081-2.238 2.08-2.18V16.56l-3.667 3.885zM19.95 24.26v-1.715H15.4V21.32h4.408v-1.715H15.4V18.38h4.55v-1.82l3.667 3.885zM15.118 9.63l-1.093 2.555h2.15z"
    ></path>
  </svg>
);

export { AmericanExpressIcon };
